import { GiftTypeStyles } from './HistoryStyles'

const GiftType = props => (
    <GiftTypeStyles>
      <span className={ props.original.revenueType === 'GF'? 'has-dash' : '' }>{ props.original.revenueTypeFull }</span>
      { props.original.revenueType === 'GF' && <span>{ props.original.paymentMethod }</span> }
    </GiftTypeStyles>
)

export default GiftType